import { FC } from 'react';
import styled from 'styled-components';
import { DefaultList, ListStyleProvider } from '@clds/compound-components';
import { MenuProvider } from '@clds/menu-old';
import Drawer from '@cld/drawer';
import { MobileMenuPaper } from '@cld/mobile-menu';
import { MobileMenuHeader } from '../../DropdownMobileMenu';
import { useCustomMenuState } from './useCustomMenu';
import { CustomMobileMenuProps } from './CustomDropdownMenu.typs';
import { MENU_ITEM_HEIGHT } from './CustomDropdownMenu';

export const CustomMobileMenu: FC<CustomMobileMenuProps> = ({ backdropClickHandler, searchBar, footer, headerTitle, isOpened, ...rest }) => {
  const { menu, dropdownMenu } = useCustomMenuState(rest);

  return (
    <StyledDrawer open={isOpened} onBackdropClick={backdropClickHandler} position="bottom">
      <MobileMenuPaper>
        <MenuProvider {...menu.menuProviderProps}>
          <ListStyleProvider selectionVariant="subtle" borderRadius="md">
            <DefaultList ref={menu.descendantsParentRef}>
              <MobileMenuHeader headerTitle={headerTitle} onClose={backdropClickHandler} />
              <ScrollableWrapper>{dropdownMenu.connectedItems}</ScrollableWrapper>
              {searchBar}
              {footer}
            </DefaultList>
          </ListStyleProvider>
        </MenuProvider>
      </MobileMenuPaper>
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  width: revert;
  height: revert;
  left: 50%;
  transform: translateX(-50%);
`;

const ScrollableWrapper = styled.div`
  max-height: calc(5 * ${MENU_ITEM_HEIGHT}); // 5 items * MENU_ITEM_HEIGHT
  overflow-y: auto;
`;
